import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { DisplayIconFactory } from './display-icon-factory.interface';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class GaugeFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        return {
            getLabelText: () => '',
            getUnits: () => '',
            icon: item.graphicBehavior as string,
            isLabelVisible: () => false,
            getValue: () => item.value
        };
    }
}
